export default {
  "content": "<g fill-rule=\"evenodd\" clip-rule=\"evenodd\"><path d=\"M5 8.5c0-1.66 1.34-3 3-3s3 1.34 3 3-1.34 3-3 3-3-1.34-3-3zm5 0c0-1.1-.9-2-2-2s-2 .9-2 2 .9 2 2 2 2-.9 2-2z\"/><path d=\"M10.01 3h5.04c.52 0 .95.43.95.95v9.1c0 .52-.43.95-.95.95H.95c-.52 0-.95-.43-.95-.95v-9.1C0 3.43.43 3 .95 3h5.06c0-.55.45-1 1-1h2c.55 0 1 .45 1 1zM1 4v9h14V4H1z\"/></g>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "16",
    "height": "16",
    "fill": "currentColor",
    "viewBox": "0 0 16 16"
  }
};